import imRequest from '../imRequest';
import { IM_API } from '../../constants/endpoints';

export const pinApi = {
  list: (conversationId) =>
    imRequest.get(`${IM_API}/conversations/${conversationId}/pins`),

  pin: (conversationId, serverMessageId) =>
    imRequest.put(`${IM_API}/conversations/${conversationId}/pins/${serverMessageId}`),

  unpin: (conversationId, serverMessageId) =>
    imRequest.delete(`${IM_API}/conversations/${conversationId}/pins/${serverMessageId}`),
};
